import * as React from 'react';
import * as main from "../../styles/main.module.scss";
import * as structure from "./style.module.scss";

export const Structure = () => {
  const swiperEl = React.useRef();
  React.useEffect(() => {
    if (swiperEl.current) {
      Object.assign(swiperEl.current, {
        slidesPerView: 1,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
      });
      swiperEl.current.initialize();
    }
  }, []);
  return (
    <section className={structure.structure}>
      <div className="container" style={{position: "unset"}}>
        <h3 className={`${main.title_h3} ${structure.structure__title}`}>Как устроен курс</h3>
        <div className={structure.structure__blocks}>
          <div className={structure.structure__block}>
            <img src="https://fs.advance.ru/landing-pages/online/kak_nauchit_rebenka_chitat_2/kurs-icon-01.svg" alt=""/>
              <h5>Видеоуроки для родителей.</h5>
              <p>Вы узнаете методы и упражнения, которые позволят повысить скорость и качество чтения, а также
                попробуете их на практике. Уроки необходимо посмотреть до того, как вы начнёте заниматься с
                ребёнком.</p>
          </div>
          <div className={structure.structure__block}>
            <img src="https://fs.advance.ru/landing-pages/online/kak_nauchit_rebenka_chitat_2/kurs-icon-02.svg" alt=""/>
              <h5>Занятия на платформе-тренажёре.</h5>
              <p>Игры и упражнения помогут развить память, внимание, расширить поле зрения. Ребёнок научится лучше
                понимать смысл прочитанного. Рекомендуем использовать тренажёр перед работой с книгой, чтобы
                «разогнаться».</p>
          </div>
          <div className={structure.structure__block}>
            <img src="https://fs.advance.ru/landing-pages/online/kak_nauchit_rebenka_chitat_2/kurs-icon-03.svg" alt=""/>
              <h5>Работа с книгой.</h5>
              <p>Мы подготовили 15 захватывающих историй про детектива Пипера — ребёнок почувствует себя участником
                сюжета и выполнит развивающие задания по ходу чтения. Книга также содержит 15 уроков с дополнительными
                текстами на технику чтения.</p>
          </div>
        </div>
        <div className={structure.structure__content}>

          <swiper-wrapper style={{ position: "relative" }}>
            <swiper-container
              ref={swiperEl}
              init="false"
              style={{
                width: "100%",
                overflowX: "hidden",
                paddingBottom: "35px",
                gridColumn: 1,
                gridRow: 1
              }}
            >
              <swiper-slide>
                <img src="https://fs.advance.ru/landing-pages/online/kak_nauchit_rebenka_chitat_2/screen1.png" alt=""/>
              </swiper-slide>
              <swiper-slide>
                <img src="https://fs.advance.ru/landing-pages/online/kak_nauchit_rebenka_chitat_2/screen2.png" alt=""/>
              </swiper-slide>
              <swiper-slide>
                <img src="https://fs.advance.ru/landing-pages/online/kak_nauchit_rebenka_chitat_2/screen3.png" alt=""/>
              </swiper-slide>
              <swiper-slide>
                <img src="https://fs.advance.ru/landing-pages/online/kak_nauchit_rebenka_chitat_2/screen4.png" alt=""/>
              </swiper-slide>
            </swiper-container>
            <div
              class="swiper-pagination"
              style={{
                "--swiper-pagination-bullet-size": "13px",
                "--swiper-pagination-color": '#9633FB'
              }}
            />
          </swiper-wrapper>

          <p className={structure.structure__sliderUndertext}>Примеры уроков</p>

          <div className={structure.structure__text}>
            <ul>
              <li className={structure.structure__textItem}>
                <strong>Занятия</strong> в любое удобное время из любой точки мира.
              </li>
              <li className={structure.structure__textItem}>
                Возможность проходить курс с <strong>комфортной</strong> для
                ребёнка <strong>интенсивностью.</strong>
              </li>
              <li className={structure.structure__textItem}>
                <strong>Доступ к нашей обучающей платформе на 4 года:</strong> в течение этого времени вы можете возвращаться к урокам по мере необходимости.
              </li>
              <li className={structure.structure__textItem}>
                <strong>Поддержка кураторов:</strong> пока открыт доступ к курсу, вы в любой момент можете обратиться за экспертной помощью по вопросам обучения.
              </li>
              <li className={structure.structure__textItem}>
                <strong>Прогресс-шкала на платформе с тренажёрами</strong> поможет поддержать мотивацию ребёнка.
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};
